var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAuth)?_c('div',{staticClass:"c-script-page"},[_c('Script')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }